import { render, staticRenderFns } from "./singleContainerReport.vue?vue&type=template&id=8a4e4d70&scoped=true"
import script from "./singleContainerReport.vue?vue&type=script&lang=js"
export * from "./singleContainerReport.vue?vue&type=script&lang=js"
import style0 from "./singleContainerReport.vue?vue&type=style&index=0&id=8a4e4d70&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4e4d70",
  null
  
)

export default component.exports